// @flow
import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import withLayout from '../components/Layout';
import withRouter from '../helpers/withRouter';
import { allFlattenRoutes as routes } from './index';
import RequireAuth from './RequireAuth';
import PageNotFound from '../pages/PageNotFound';
import Loading from '../components/Loading';

const AppRouter = () => {
    const NotFoundPage = withLayout(PageNotFound);

    return (
        <BrowserRouter>
            <Suspense fallback={<Loading />}>
                <Routes>
                    {routes.map((route, index) => {
                        const PageComponent = route.component;
                        if (!PageComponent) {
                            return null;
                        }
                        const PageWithLayout = withLayout(withRouter(PageComponent));
                        const element = route.private
                            ? <RequireAuth path={route.path}><PageWithLayout /></RequireAuth>
                            : <PageWithLayout />;

                        return (
                            <Route
                                key={index}
                                path={route.path}
                                element={element}
                            />
                        );
                    })}

                    {/* 404 fallback */}
                    <Route path="*" element={<RequireAuth><NotFoundPage /></RequireAuth>} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};

export default AppRouter;
